import React, { useContext } from 'react'
import { Typography, List } from '@material-ui/core'
import GroupCostBox from '../GroupCostBox'
import { CalculatorContext } from '../Context/CalculatorContext'
import GroupCostLine from '../GroupCostBox/GroupCostLine'

const Summary = ({ cost, migrationCost, proxyRegenerationCost }) => {
    const { currency } = useContext(CalculatorContext)
    return (
        <div>
            <GroupCostBox currency={currency} cost={cost} title="Summary">
                {migrationCost || proxyRegenerationCost > 0 ? (
                    <>
                        <Typography variant="body1" color="textPrimary">
                            One-off costs
                        </Typography>
                        <List>
                            {migrationCost ? (
                                <li style={{ marginLeft: 8 }}>
                                    <GroupCostLine
                                        label="Migration"
                                        total={migrationCost}
                                    />
                                </li>
                            ) : null}
                            {proxyRegenerationCost ? (
                                <li style={{ marginLeft: 8 }}>
                                    <GroupCostLine
                                        label="Proxy regeneration"
                                        total={proxyRegenerationCost}
                                    />
                                </li>
                            ) : null}
                        </List>
                    </>
                ) : null}
            </GroupCostBox>
        </div>
    )
}

export default Summary
